import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Phone, ChevronDown, MessageCircle } from "lucide-react";

export const PublicHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const links = [
    { name: "Fleet", path: "/fleet" },
    { name: "Tours & Packages", path: "/tours" },
    { name: "Airport Transfers", path: "/services/airport-transfers" },
    { name: "Minibus Charter", path: "/services/minibus-charter" },
    { name: "Weddings", path: "/services/weddings" },
    { name: "Contact", path: "/contact" }
  ];
  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Gold top bar */}
      <div className="bg-gradient-to-r from-amber-600 via-amber-500 to-amber-600 text-gray-950">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-8 text-xs font-semibold">
          <span className="hidden sm:block tracking-wide">Australia-wide chauffeurs · Fixed prices · Available 24/7</span>
          <div className="flex items-center gap-4 ml-auto">
            <a href="https://wa.me/61481437772" target="_blank" rel="noreferrer" className="flex items-center gap-1 hover:opacity-75 transition-opacity" data-testid="topbar-whatsapp">
              <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
            </a>
            <a href="tel:+61481437772" className="flex items-center gap-1 hover:opacity-75 transition-opacity" data-testid="header-phone">
              <Phone className="h-3.5 w-3.5" /> +61 481 437 772
            </a>
          </div>
        </div>
      </div>
      {/* Main nav */}
      <div className="bg-gray-950/90 backdrop-blur-xl border-b border-amber-500/20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center" data-testid="header-logo-link">
              <img src="/logo-dark.png" alt="Limo Near Me" className="h-9 w-auto" />
            </Link>
            <nav className="hidden lg:flex items-center gap-7">
              {links.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`text-sm font-medium transition-colors ${location.pathname === l.path ? "text-amber-400" : "text-gray-300 hover:text-amber-400"}`}
                >
                  {l.name}
                </Link>
              ))}
            </nav>
            <div className="hidden lg:flex items-center gap-3">
              <Link to="/login">
                <Button variant="ghost" size="sm" className="text-gray-300 hover:text-white hover:bg-white/10" data-testid="header-login-btn">Login</Button>
              </Link>
              <Link to="/book">
                <Button size="sm" className="rounded-full px-6 font-bold shadow-lg shadow-amber-500/25" data-testid="header-book-btn">Book Now</Button>
              </Link>
            </div>
            <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={open ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
              </svg>
            </button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden bg-gray-950 border-t border-white/10 py-4 px-4">
            <div className="flex flex-col gap-4">
              {links.map((l) => (
                <Link key={l.path} to={l.path} className="text-gray-300" onClick={() => setOpen(false)}>{l.name}</Link>
              ))}
              <a href="tel:+61481437772" className="text-amber-400 font-semibold">+61 481 437 772</a>
              <Link to="/book" onClick={() => setOpen(false)}><Button className="w-full rounded-full font-bold">Book Now</Button></Link>
              <Link to="/login" onClick={() => setOpen(false)}><Button variant="outline" className="w-full border-white/20 text-white">Login</Button></Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default PublicHeader;
